import PageLayout from '../components/layout/PageLayout'
import ClientList from 'components/lists/clients/ClientsList'

export default function ClientsPage() {
  return (
    <PageLayout pageTitle='Clientes' pageDesc='Altas, bajas y modificaciones.'>
      <ClientList />
    </PageLayout>
  )
}